import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'stringEmpty' })
export class StringEmptyPipe implements PipeTransform {
  transform(value: string | undefined): string {
    return value ? value : '--';
  }
}
